module.exports = __webpack_public_path__ + "view/2019/img/group-3@3x.png";